import React from "react";
export default function KullanımSartlari() {
  return (
    <div class="page">
      <h1>Kullanım Şartları</h1>
      <div>
       
       
           
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Reprehenderit maiores voluptatum tenetur modi doloremque odit
            placeat neque eveniet, cumque possimus iure esse praesentium debitis
            quaerat tempora quo sequi magni nisi!
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Reprehenderit maiores voluptatum tenetur modi doloremque odit
            placeat neque eveniet, cumque possimus iure esse praesentium debitis
            quaerat tempora quo sequi magni nisi!
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Reprehenderit maiores voluptatum tenetur modi doloremque odit
            placeat neque eveniet, cumque possimus iure esse praesentium debitis
            quaerat tempora quo sequi magni nisi!
          </p>
         
      </div>
    </div>
  );
}
